import { render, staticRenderFns } from "./newEstateTab.vue?vue&type=template&id=71e801dd&scoped=true&"
import script from "./newEstateTab.vue?vue&type=script&lang=js&"
export * from "./newEstateTab.vue?vue&type=script&lang=js&"
import style0 from "./newEstateTab.vue?vue&type=style&index=0&id=71e801dd&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71e801dd",
  null
  
)

export default component.exports